/**
 * Compact footer used on pre-authentication pages (login, register,
 * activate, forgot-password, reset-password). These pages don't
 * render under CustomerLayout so they never get the full Footer --
 * this stripped-down version ensures the Privacy Policy link is
 * always visible before a user commits to any action that involves
 * their personal data (login, signup, password reset).
 *
 * Kept intentionally minimal (privacy link + copyright) so it doesn't
 * distract from the auth form.
 */

import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PRIVACY_POLICY_URL = 'https://mowilex.com/en/privacy-policy/';

const PublicPageFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: 3,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      <Link
        href={PRIVACY_POLICY_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="body2"
        color="text.secondary"
        underline="hover"
      >
        {t('footer.privacyPolicy')}
      </Link>
      <Typography variant="caption" color="text.secondary">
        {t('footer.copyright', { year: new Date().getFullYear() })}
      </Typography>
    </Box>
  );
};

export default PublicPageFooter;
